import React from "react";

import { Link } from "react-router-dom"; 

const FactoryAutomationVideoCard_2 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">O-RING ASSEMBLY</h5>
        <p className="card-text">
          This project was very entretain and with a lot of challanges, it was an application that several automation houses tried
          in the pass with no success. We did a very good proof of concept (PoC), I strongly belive that head us to be succesful.
        </p>

        <h6>
          Investment: <span>$390,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>8 months</span>
        </h6>
        <h6>
          Savings: <span>12 re-located DL</span>
        </h6>
        <h6>
          Technology: <span>Full Automatic Machine, Rotary Indexer, 12 Stations, Robots, 
            Visions systems, Bowl Feeders, Ultrasonic Welding, Flexible Feeders</span>
        </h6>
      </div>
    </div>
  );
};

export default FactoryAutomationVideoCard_2;